import React, { useEffect, useState } from 'react';
import { usePDF } from '@react-pdf/renderer';

export const EFlyerPDF = ({ children }) => {
  const [pdfData, setPdfData] = useState(null);
  const [pdfError, setPdError] = useState(null);
  const [ready, setReady] = useState(false);

  const [instance, updateInstance] = usePDF({ document: children });

  useEffect(() => {
    if (instance.loading) return;
    if (instance.error) {
      setPdError(instance.error);
      return;
    }

    setPdfData(URL.createObjectURL(instance.blob));
    setReady(true);
  }, [instance]);

  if (!ready) {
    return null;
  }

  return (
    <div style={{ height: '80vh', width: '100%' }}>
      <object data={pdfData} type="application/pdf" width="100%" height="100%">
        <p>Unable to display PDF.</p>
      </object>
    </div>
  );
};
